import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.blue};
    width: 100%;
    > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        max-width: 1232px;
        width: 100%;
        margin: auto;
        > p {
            margin: 0;
            font-size: 14px;
        }
        > button {
            outline: none;
            cursor: pointer;
            border: 1px solid white;
            background-color: unset;
            text-transform: uppercase;
            color: white;
            border-radius: 6px;
            padding: 8px 16px;
            font-weight: bold;
            font-size: 10px;
        }
        @media screen and (max-width: 960px) {
            flex-direction: column;
            height: auto;
            padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 4}px;
            align-items: flex-start;
            > p {
                margin-bottom: ${({ theme }) => theme.spacing * 2}px;
            }
        }
    }
`;